import { useEffect, useState } from 'react';
import 'bootstrap/dist/js/bootstrap.min.js';
import Modal from "react-bootstrap/Modal";
import gEventRouter from "../script/event_router.js";
import gUtilities from '../script/utilities';
import gSession from '../script/session';

import PromptPasswordDialog from './PromptPasswordDialog.js';

function JobDialog() {
    const [job, setJob] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [promptCredentials, setPromptCredentials] = useState(false);

    const showModal = (data) => {
        setIsOpen(true);
        setJob(data);
    };

    const hideModal = () => {
        setIsOpen(false);

        setPromptCredentials(false);
    };

    gEventRouter.register("JobDialog.showModal", showModal);

    function allowCancelButton() {
        if (!job) {
            return false;
        }

        let isRunning = job.state !== "S_SUCCESS" && job.state !== "S_FAILURE";

        if (isRunning) {
            return true;
        } else {
            return false;
        }
    }

    function allowLaunchButton() {
        if (!job) {
            return false;
        }

        let isPending = job.state === "S_CONFIGURATION";
        let isMcnp = job.simulator_name === "mcnp";

        return isPending && isMcnp;
    }

    function onCancel() {
        let data = {
            action: "Cancel Job",
            message: "Stop processing of this job",
            callback: (decision) => {
                if (decision) {
                    cancel();
                }
            }
        };

        gEventRouter.invoke("ConfirmationDialog.showModal", data);
    }

    async function cancel() {
        let request = {
            command: "job.cancel",
            job_id: job.job_id
        };

        let response = await gSession.exchange(request);
        if (response.isError) {
            gUtilities.showError("Cancel Job", response.message);
        }

        hideModal();
    }

    async function onLaunch() {
        setPromptCredentials(true);
    }

    async function onCredentials(username, onceword) {
        let request = {
            command: "job.mcnp_permission",
            job_id: job.job_id,
            username: username,
            onceword: onceword
        };

        let response = await gSession.exchange(request);
        if (response.isError) {
            gUtilities.showError("Allow MCNP", response.message);
        } else {
            hideModal();
        }
    }

    useEffect(() => {
        let widget = document.querySelector("#w_JobJobIdField");
        if (widget) {
            widget.value = job.job_id;
        }
    }, [job]);

    return (
        <div>
            <Modal show={isOpen}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Job Actions</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="col-form-label mt-1" htmlFor="w_JobJobIdField">Job ID</label>
                            <input type="text" className="form-control" readOnly="" placeholder="Job ID" id="w_JobJobIdField"></input>
                            <ul className="list-group">
                                {
                                    job && Object.keys(job).map(key => (
                                        <li key={key} className="list-group-item d-flex justify-content-between align-items-center">
                                            {key}
                                            <span className="badge bg-primary rounded-pill">{job[key]}</span>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={hideModal}>Close</button>
                        {
                            allowCancelButton() &&
                            <button type="button" className="btn btn-primary" id="w_JobCancelButton" onClick={onCancel}>Cancel</button>
                        }
                        {
                            allowLaunchButton() &&
                            <button type="button" className="btn btn-primary" id="w_JobLaunchButton" onClick={onLaunch}>Launch</button>
                        }
                    </div>
                </div>
            </Modal>
            {promptCredentials &&
                <PromptPasswordDialog group="mcnp" onConfirm={onCredentials} />
            }
        </div>
    )
}

export default JobDialog;